/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_NewestInputs */

const en_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newest`)
};

const es_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más reciente`)
};

const fr_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le plus récent`)
};

const de_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste`)
};

const ja_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新着順`)
};

const zh_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新`)
};

const ar_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأحدث`)
};

const id_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaru`)
};

const it_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più Recenti`)
};

const ru_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сначала новые`)
};

const pt_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais Recentes`)
};

const ko_search_sort_newest = /** @type {(inputs: Search_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신순`)
};

/**
* | output |
* | --- |
* | "Newest" |
*
* @param {Search_Sort_NewestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_sort_newest = /** @type {((inputs?: Search_Sort_NewestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_NewestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_sort_newest(inputs)
	if (locale === "es") return es_search_sort_newest(inputs)
	if (locale === "fr") return fr_search_sort_newest(inputs)
	if (locale === "de") return de_search_sort_newest(inputs)
	if (locale === "ja") return ja_search_sort_newest(inputs)
	if (locale === "zh") return zh_search_sort_newest(inputs)
	if (locale === "ar") return ar_search_sort_newest(inputs)
	if (locale === "id") return id_search_sort_newest(inputs)
	if (locale === "it") return it_search_sort_newest(inputs)
	if (locale === "ru") return ru_search_sort_newest(inputs)
	if (locale === "pt") return pt_search_sort_newest(inputs)
	return ko_search_sort_newest(inputs)
});